import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import useUpdateEffect from 'Components/UseUpdateEffect/useUpdateEffect';

const BenefitItems = ({
    registrationIdsSelected,
    isActiveFilter
}) => {
    const [idBenefitItems, setIdBenefitItems] = useState(null);
    const [dsItem, setDsItem] = useState(null);
    const [sequenceId, setSequenceId] = useState(null);
    const [isActive, setIsActive] = useState('S');
    const [username, setUsername] = useState(null);
    const [updateDate, setUpdateDate] = useState(null);
    const [dsItemChanged, setDsItemChanged] = useState(null);

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [benefitItemsIdsSelecteds, setBenefitItemsIdsSelecteds] = useState([]);

    const [attributesDetailBenefitItems, setAttributesDetailBenefitItems] = useState(null);
    const [recordsBenefitItems, setRecordsBenefitItems] = useState(null);
    const [loadingBenefits, setLoadingBenefits] = useState(false);

    const readOnlyAttributes = !(inserting || updating);

    const attributeList = [
        { name: "id", value: idBenefitItems, setter: setIdBenefitItems },
        { name: "dsItem", value: dsItem, setter: setDsItem },
        { name: "idSequence", value: sequenceId, setter: setSequenceId },
        {
            name: "isActive",
            value: isActive,
            setter: setIsActive,
            resetValue: 'S',
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        { name: "username", value: username, setter: setUsername },
        { name: "dtUpdate", value: updateDate, setter: setUpdateDate },
        { name: "dsItemChanged", value: dsItemChanged, setter: setDsItemChanged }
    ];

    function onUpdateInsert(value) {
        setInserting(value)
    }

    useEffect(() => {
        setInserting(false)
        setUpdating(false)
        setBenefitItemsIdsSelecteds([])
    }, [isActiveFilter]);

    useEffect(() => {
        getBenefitItemsRecords()
    }, [isActiveFilter, registrationIdsSelected]);

    // A carga inicial é feita pelo efeito dos filtros; aqui só ao entrar/sair da edição
    useUpdateEffect(() => {
        getBenefitItemsRecords()
    }, [inserting, updating]);


    const setAttributesPanelBenefitItemDetail = async (benefitItemsIdsSelecteds) => {
        const parameters = { id: benefitItemsIdsSelecteds }
        const benefitItems = await ExecuteAxios.api('get', `/item-benefits/item-benefit-by-id/`, { params: parameters })
        if (benefitItems) {
            setAttributesDetailBenefitItems(benefitItems)
            ApplyAttributes.applyAttributes(benefitItems, attributeList)
        }

        if (!benefitItemsIdsSelecteds || benefitItemsIdsSelecteds.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };


    useEffect(() => {
        if (benefitItemsIdsSelecteds && benefitItemsIdsSelecteds.length === 1) {
            setAttributesPanelBenefitItemDetail(benefitItemsIdsSelecteds[0]);
        } else {
            setAttributesPanelBenefitItemDetail(null);
        }
    }, [benefitItemsIdsSelecteds]);

    const userControlPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '83%',
        zIndex: '0'
    };

    async function getBenefitItemsRecords() {
        const parameter = {
            isActive: isActiveFilter
        }

        const itemsBenefits = await ExecuteAxios.api('get', `/item-benefits/list-item-benefits-order-sequence/`, { params: parameter })
        setRecordsBenefitItems(itemsBenefits);
        RemoveIdsNotFound.remove(itemsBenefits, setBenefitItemsIdsSelecteds, benefitItemsIdsSelecteds)
    }

    const benefitItemsPanelListOrDetail = () => {
        if (!inserting && !updating) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setBenefitItemsIdsSelecteds}
                    idsSelected={benefitItemsIdsSelecteds}
                    data={recordsBenefitItems}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <LoadingIndicator loaded={!loadingBenefits}>
                    <AutomaticallyListedAttributes
                        list={attributesDetailBenefitItems}
                        attributeList={attributeList}
                        readOnlyAttributes={readOnlyAttributes}
                    />
                </LoadingIndicator>
            )
        }
    }

    async function postBenefitItem() {
        if (benefitItemsIdsSelecteds && benefitItemsIdsSelecteds.length === 0) {
            try {
                setLoadingBenefits(true)
                return await ExecuteAxios.api('post', `/item-benefits/`, {
                    dsItem: dsItem,
                    sequenceId: sequenceId,
                    isActive: isActive
                });
            } finally {
                setLoadingBenefits(false)
            }
        }
    }

    async function putBenefititem() {
        if (benefitItemsIdsSelecteds && benefitItemsIdsSelecteds.length === 1) {
            try {
                setLoadingBenefits(true)
                return await ExecuteAxios.api('put', `/item-benefits/`, {
                    id: idBenefitItems,
                    dsItem: dsItem,
                    sequenceId: sequenceId,
                    isActive: isActive
                });
            } finally {
                setLoadingBenefits(false)
            }
        }
    }

    return (
        <LoadingIndicator loaded={!loadingBenefits}>
            <Panel
                titlePage='Itens do Benefício'
                style={userControlPanelStyle}
                setUpdating={setUpdating}
                setInserting={onUpdateInsert}
                inserting={inserting}
                updating={updating}
                enableEdit={true}
                canEdit={(benefitItemsIdsSelecteds && benefitItemsIdsSelecteds.length === 1)}
                putFunction={putBenefititem}
                enableNewRecord={true}
                canNewRecord={true}
                postFunction={postBenefitItem}
                canViewCRUD={true}
                readOnly={false}
                recordsSelected={benefitItemsIdsSelecteds}
                viewOnlyOneRecordCRUD={true}
                resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                dataListedAttributes={attributesDetailBenefitItems}
                attributeList={attributeList}
                onUpdateIdSelected={setBenefitItemsIdsSelecteds}
            >
                {benefitItemsPanelListOrDetail()}
            </Panel>
        </LoadingIndicator>
    );
};

export default BenefitItems;


